/** sessionStorage key for flash message on login after org / site mismatch */
export const AUTH_ORG_ORIGIN_ERROR_KEY = "launchflow_auth_org_origin_error";

export const API_UNREACHABLE_MESSAGE =
  "Cannot reach the application server. Please check your network, VPN, firewall, or API gateway configuration, then try again.";

/** Normalize stored org frontend_base_url for comparison with window.location.origin. */

export function normalizeFrontendOrigin(url: string): string {
  try {
    return new URL(url.trim()).origin.toLowerCase();
  } catch {
    return "";
  }
}

/** When true, only orgs whose frontendBaseUrl matches the current site are used (see server ENFORCE_ORG_ORIGIN). */
export function shouldEnforceOrgOrigin(): boolean {
  if (import.meta.env.VITE_ENFORCE_ORG_ORIGIN === "0") return false;
  if (import.meta.env.VITE_ENFORCE_ORG_ORIGIN === "1") return true;
  return import.meta.env.PROD;
}
